import { useState } from "react"
import { Modal } from "../../common"
import { ReactComponent as DemoMan } from "../../../assets/icons/demoMan.svg"
import { ReactComponent as OrangeEmail } from "../../../assets/icons/orangeEmail.svg"
import { ReactComponent as OrangePhone } from "../../../assets/icons/orangePhone.svg"


export const CustomSolutionBanner = () => {
    const [showModal, setShowModal] = useState(false)
    const modalClose = () => {
        setShowModal(false)
    }
    return (
        <>
            <div style={{ "marginBottom": "25px" }} className="bg-white rounded-md py-4 px-1">
                <div className="sm:flex justify-between p-4 gap-12">
                    <div className="text-left">
                        <h3 className="font-bold text-f18 md:text-f24">Enterprise Solution</h3>
                        <p className="text-secondary text-f">Stay tuned for tailor-made solutions, offering advanced features and seamless integration for enterprises seeking more than just monthly profile views!</p>
                    </div>
                    <div className="my-4 sm:my-auto md:comingSoon">
                        <div onClick={() => setShowModal(true)} className="cursor-pointer bg-primary text-white w-full sm:w-auto py-2 px-4 rounded-md">Contact Us</div>
                    </div>
                </div>
            </div>
            {showModal && <Modal modalHandle={modalClose}>
                <div className="max-h-screen overflow-scroll no-scrollbar flex flex-col md:flex-row justify-center items-center gap-3 md:gap-5 p-7">
                    <DemoMan className="max-w-[229px]"/>
                    <div className="max-w-[286px] flex flex-col gap-6 items-center justify-center border border-[#EBF0F3] rounded-[16px] p-8">
                        <p className="text-[#012234] font-semibold">We’re Here to Help</p>
                        <p className="text-[11px] text-[#3C4848]">Reach out via email or phone anytime. We’ll do our best to assist quickly.</p>
                        <div className="w-full flex flex-col items-center justify-center gap-6 text-[#777F7F] text-[13px]">
                            <div onClick={() => window.location.href = "mailto:info@trevex.io"} className="w-full flex gap-2 justify-center items-center p-3 border border-[#EBF0F3] rounded-full">
                                <OrangeEmail className="w-[27px] h-[27px]" />
                                <p className="w-[104px] text-left">info@trevex.io</p>
                            </div>
                            <div
                                onClick={() => (window.location.href = "tel:+97144019456")}
                                className="w-full flex gap-2 justify-center items-center p-3 border border-[#EBF0F3] rounded-full"
                                style={{ cursor: "pointer" }}
                            >
                                <OrangePhone className="w-[27px] h-[27px]" />
                                <p className="w-[104px] text-left">+971 4 4019456</p>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>}
        </>
    )
}
